import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import logoFlame from '../../../../Assets/images/gases_logo_flame.png';
import logoEfigas from '../../../../Assets/images/efg/efigas_logo_completo.svg';
import { useMediaQuery } from '@material-ui/core';

const LogoHeaderEFG = () => {
  // * OTHER HOOKS
  const classes = useStyles();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

  // * FUNCTIONS
  const renderLogo = () => {
    if (isSmallScreen) {
      return <img src={logoFlame} alt="flame" className={classes.imageSmall} />;
    }

    return (
      <>
        <img
          src={logoEfigas}
          alt="logo_Efigas_portal"
          className={classes.logo}
        />
      </>
    );
  };

  return (
    <a href="/" className={classes.centerLogo}>
      {renderLogo()}
    </a>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',
    justifyContent: 'flex-start'
  },
  imageSmall: {
    cursor: 'pointer',
    width: 40
  },
  logo: {
    cursor: 'pointer',
    width: '128.3px',
    height: 56
  },
  biglogo: {
    cursor: 'pointer',
    width: '128.3px',
    height: 56
  },
  imageText: {
    marginTop: theme.spacing(0.5),
    height: '42px',
    width: '180px'
  },
  imageFlame: {
    height: '50px',
    width: '40px'
  },
  centerLogo: {
    justifyContent: 'center',
    display: 'flex'
  }
}));

export default LogoHeaderEFG;
